export type UserRole = 'ROLE_ADMIN' | 'ROLE_USER';
export const UserRole = {
  ROLE_ADMIN: 'ROLE_ADMIN' as UserRole,
  ROLE_USER: 'ROLE_USER' as UserRole,
};
export const availableRoles: { name: string, value: UserRole }[] = [
  { name: 'Reiter', value: 'ROLE_USER' },
  { name: 'Administrator', value: 'ROLE_ADMIN' },
];

export type Feature = '';
export const availableFeatures: { label: string, value: Feature }[] = [];

export type Weekday = 'monday' | 'tuesday' | 'wednesday' | 'thursday' | 'friday' | 'saturday' | 'sunday';
export const availableWeekdays: { key: Weekday, label: string }[] = [
  { key: 'monday', label: 'Montag' },
  { key: 'tuesday', label: 'Dienstag' },
  { key: 'wednesday', label: 'Mittwoch' },
  { key: 'thursday', label: 'Donnerstag' },
  { key: 'friday', label: 'Freitag' },
  { key: 'saturday', label: 'Samstag' },
  { key: 'sunday', label: 'Sonntag' }
];
export const availableWeekdayValues = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
export const weekdayTranslation = {
  monday: 'Montag',
  tuesday: 'Dienstag',
  wednesday: 'Mittwoch',
  thursday: 'Donnerstag',
  friday: 'Freitag',
  saturday: 'Samstag',
  sunday: 'Sonntag',
};

export type Gender = 'male' | 'female' | 'divers';
export const genders: { label: string, value: Gender }[] = [
  { label: 'Herr', value: 'male' },
  { label: 'Frau', value: 'female' },
  { label: 'Divers', value: 'divers' },
];

export const mediaServerUrl500 = 'https://p500.media.calvendo.net';
export const mediaServerUrl800 = 'https://p800.media.calvendo.net';

export type LanguageCode = 'de' | 'en' | 'fr' | 'nl' | 'es';
export const languageMap: { [key: string]: string } = {
  de: 'Deutsch',
  en: 'Englisch',
  fr: 'Französisch',
  nl: 'Niederländisch',
  es: 'Spanisch',
};

export const mediumMap = {
  KAL: 'Kalender',
  CANVAS: 'Leinwand',
  PUZZLE: 'Puzzle',
  PLANNER: 'Familienplaner',
  BOOK: 'Buch',
};

export const jobQualifierMap = {
  VLB_PRODUCT_EXPORT: 'VLB',
  KNV_PRODUCT: 'KNV',
  CVKMASTERDATA_CSVEXPORT: 'CVK',
  BUCH24_ONIX: 'BUCH24',
  BOD_PRODUCT: 'BoD',
};

export const formatMap = {
  BOOKCFORM2217: 'book4ideas classic',
  BOOKMFORM2217: 'book4ideas modern',
  '120x80': 'Leinwand quer 120x80cm',
  '30x45': 'Leinwand hoch 30x45cm',
  '45x30': 'Leinwand quer 45x30cm',
  '50x75': 'Leinwand hoch 50x75cm',
  '60x90': 'Leinwand hoch 60x90cm',
  '75x50': 'Leinwand quer 75x50cm',
  '80x120': 'Leinwand quer 80x120cm',
  '90x60': 'Leinwand quer 90x60cm',
  A2H: 'Kalender Din A2 hoch',
  A2Q: 'Kalender Din A2 quer',
  A3H: 'Kalender Din A3 hoch',
  A3Q: 'Kalender Din A3 quer',
  A4H: 'Kalender Din A4 hoch',
  A4Q: 'Kalender Din A4 quer',
  A5H: 'Kalender Din A5 hoch',
  A5Q: 'Kalender Din A5 quer',
  PA2H: 'Premium Kalender Din A2 hoch',
  PA2Q: 'Premium Kalender Din A2 quer',
  SQ12IN: 'Kalender square',
  2145: 'Familienplaner',
  '48x64': 'Puzzle 1000 Teile hoch',
  '64x48': 'Puzzle 1000 Teile quer',
  '67x90': 'Puzzle 2000 Teile hoch',
  '90x67': 'Puzzle 2000 Teile quer',
  TAPETEFORM1860x1240: 'Wandtapete 186x124cm',
  TAPETEFORM2790x1860: 'Wandtapete 279x186cm',
  TAPETEFORM3720x2480: 'Wandtapete 372x248cm',
  TAPETEFORM4650x3100: 'Wandtapete 465x310cm',
  A4X2Q: 'Doppel Din',
};
